// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2NkVQ","rootSuccess":"CompleteLink_rootSuccess__1IoQw","rootFailure":"CompleteLink_rootFailure__3bUEx","isDisabled":"CompleteLink_isDisabled__22VRR"};